import React from 'react';
interface SacredGeometryProps {
  className?: string;
  color?: string;
}
export function SacredGeometry({
  className = '',
  color = '#00A99D'
}: SacredGeometryProps) {
  return <svg className={className} viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{
    opacity: 0.05
  }} data-id="element-387">
      <circle cx="100" cy="100" r="90" stroke={color} strokeWidth="1" data-id="element-388" />
      <circle cx="100" cy="55" r="45" stroke={color} strokeWidth="1" data-id="element-389" />
      <circle cx="100" cy="145" r="45" stroke={color} strokeWidth="1" data-id="element-390" />
      <circle cx="61" cy="77.5" r="45" stroke={color} strokeWidth="1" data-id="element-391" />
      <circle cx="139" cy="77.5" r="45" stroke={color} strokeWidth="1" data-id="element-392" />
      <circle cx="61" cy="122.5" r="45" stroke={color} strokeWidth="1" data-id="element-393" />
      <circle cx="139" cy="122.5" r="45" stroke={color} strokeWidth="1" data-id="element-394" />
      <circle cx="100" cy="100" r="45" stroke={color} strokeWidth="1" data-id="element-395" />
    </svg>;
}